import type { MediaCoordinator } from '../media/MediaCoordinator';
import type { PavilionCoordinator } from '../pavilion/PavilionCoordinator';
import type { driverState } from '../../api/stores/shared';
import { setLegacyMatchmakerShadowcamHealthSource } from '../../api/modules/managers/matchmaker';

/** Keeps the existing media prerequisite initialization together at the Host composition boundary. */
export async function initializeMediaRuntime(enabled: boolean, media: MediaCoordinator, pavilion: PavilionCoordinator,
  drivers: Pick<typeof driverState, 'addListener'>): Promise<void> {
  if (!enabled) { console.log('[Coordinators] 🚧 MediaCoordinator skipped (feature flag disabled)'); return; }
  await media.init();
  media.reportDriverStatus();
  drivers.addListener(() => media.reportDriverStatus());
  const shadowcamHealthSource = media.getShadowcamPresenceMonitor();
  pavilion.setShadowcamHealthSource(shadowcamHealthSource);
  setLegacyMatchmakerShadowcamHealthSource(shadowcamHealthSource);
  console.log('[Coordinators] ✓ MediaCoordinator initialized');
}
